import $ from "jquery";
import { Datepicker } from "vanillajs-datepicker";
var moment = require("moment");
import swal from "sweetalert";
$(document).ready(function () {
    var datesDisabled = [];
    if ($('.page-template-tpl-reservation').length || $('.page-template-tpl-checkout').length) {
        var i = 1;
        var canOrderInTheFuture = true;
        if ($('#dateinfos').length && $('#dateinfos').data("can-order-future") !== void 0) {
            canOrderInTheFuture = $('#dateinfos').data("can-order-future") == "yes";
        }
        for (i; i < 365; i++) {
            datesDisabled.push(moment().subtract(i, 'days').format("DD/MM/YYYY"));
            if (!canOrderInTheFuture)
                datesDisabled.push(moment().add(i, 'days').format("DD/MM/YYYY"));
        }
    }
    //
    if ($('.page-template-tpl-reservation').length) {
        var res = document.querySelector('#fld_4700247_1');
        var fld_4700247_1 = new Datepicker(res, {
            autohide: true,
            daysOfWeekDisabled: [0],
            language: 'fr',
            format: 'dd/mm/yyyy',
            datesDisabled: datesDisabled
        });
    }
    if ($('.page-template-tpl-checkout').length) {
        $("#customer_details, #order_review_heading, #order_review, .woocommerce-form-login-toggle").hide();
        var loginToggle = $('.woocommerce-form-login-toggle');
        var formLogin = $('.woocommerce-form.woocommerce-form-login');
        var checkoutForm_1 = $('form.woocommerce-checkout');
        var options = $("#options");
        var addons = $('#wc_checkout_add_ons');
        var viewFields_1 = $('#view-fields');
        //
        var elem = document.querySelector('#datepicker');
        var dateinfos = $("#dateinfos");
        var disabledDays = dateinfos.data("disabled-days");
        var datepicker = new Datepicker(elem, {
            autohide: true,
            daysOfWeekDisabled: disabledDays,
            language: 'fr',
            format: 'dd/mm/yyyy',
            datesDisabled: datesDisabled
        });
        var hoursField_1 = $("#hours-pickup");
        var dateField_1 = $('input[name="order_pickup_date"]');
        $('.remove-select2').removeClass("select").removeClass("select2-hidden-accessible").next('span').remove();
        //
        addons.detach().appendTo(options.find("#dishes"));
        options.detach().prependTo(checkoutForm_1);
        setTimeout(function () {
            checkoutForm_1.animate({ opacity: 1 }, 350);
            $('.remove-select2').removeClass("select").removeClass("select2-hidden-accessible").next('span').remove();
        }, 500);
        //
        viewFields_1.find(".location").html($('input[name="order_pickup_location"]').val());
        viewFields_1.find(".hour").html($("#hours-pickup").val());
        viewFields_1.find(".date").html(dateField_1.val());
        dateField_1.on("changeDate", function () {
            $('body').addClass("disable-form");
            viewFields_1.find(".hour").html();
            viewFields_1.find(".date").html(dateField_1.val());
            hoursField_1.val("");
            if (hoursField_1.val() != "") {
                $("#customer_details, #order_review_heading, #order_review, .woocommerce-form-login-toggle").fadeIn(350);
            }
        });
        var hoursNode = $('.fields > .hours');
        var errorTitle_1 = hoursNode.attr("data-hour-error-title");
        var errorMessage_1 = hoursNode.attr("data-hour-error-message");
        var errorHours_1 = hoursNode.attr("data-hour-error-hours");
        var morning_1 = moment().set({ hour: '10', minute: '00' });
        var night_1 = moment().set({ hour: '22', minute: '00' });
        $("#customer_details, #order_review_heading, #order_review, .woocommerce-form-login-toggle").fadeIn(350);
        function checkDate() {
            if (dateField_1.val() != "") {
                return true;
            }
            return false;
        }
        function checkHour(showPopUp) {
            if (showPopUp === void 0) { showPopUp = true; }
            if (checkDate() && hoursField_1.val() != null && hoursField_1.val() != "") {
                var hourVal = hoursField_1.val().split(":");
                var definedHour = moment().set({ 'minute': hourVal[1] !== void 0 ? hourVal[1] : '00', 'hour': hourVal[0] !== void 0 ? hourVal[0] : moment().format("HH") });
                if (dateField_1.val() == moment().format("DD/MM/YYYY")) {
                    var oneHour = moment().add(60, "minutes");
                    if (!(definedHour.format("X") >= oneHour.format("X"))) {
                        return { status: "error", type: "message" };
                    }
                    return { status: "success" };
                }
                else {
                    switch (true) {
                        case morning_1.format("X") - 1 > definedHour.format("X"):
                        case night_1.format("X") + 1 < definedHour.format("X"):
                            // $("#customer_details, #order_review_heading, #order_review, .woocommerce-form-login-toggle").hide();
                            return { status: "error", "type": "hour" };
                            break;
                        default:
                            return { status: "success" };
                            // $("#customer_details, #order_review_heading, #order_review, .woocommerce-form-login-toggle").fadeIn(350);
                            break;
                    }
                }
            }
            return false;
        }
        hoursField_1.on("change", function () {
            var resp = checkHour();
            if (resp.status == "error") {
                if (resp.type == "message") {
                    swal({
                        title: errorTitle_1,
                        text: errorMessage_1,
                        icon: "error",
                        dangerMode: true
                    });
                }
                else if (resp.type == "hour") {
                    swal({
                        title: errorTitle_1,
                        text: errorHours_1,
                        icon: "error",
                        dangerMode: true
                    });
                }
                $('body').addClass("disable-form");
            }
            else if (resp.status == "success") {
                $('body').removeClass("disable-form");
            }
            viewFields_1.find(".hour").html($("#hours-pickup").val());
        });
        $('#customer_details').prepend(formLogin.detach());
        $('#customer_details').prepend(loginToggle.detach());
        setInterval(function () {
            var resp = checkHour();
            if (checkDate() && resp.status == "success") {
                $('body').removeClass("disable-form");
            }
            else {
                $('body').addClass("disable-form");
            }
        }, 3000);
    }
});
